import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { CREATE_ANSWER, UPDATE_ANSWER, DELETE_ANSWER,BIND_TYPE_TO_ANSWER } from './constants';
import { createAnswerSuccess, updateAnswerSuccess, deleteAnswerSuccess,bindTypeToAnswerSuccess } from './actions';
import { requestAnswerCreation, requestAnswerUpdating, requestAnswerDeleting,requestBindTypeToAnswer } from './api';
import { putActionActionBuffer } from '../../actionBuffer/actions';
/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* createAnswer(actionObj){
    const updatedQuestion = yield requestAnswerCreation(actionObj.questionID, actionObj.answer, actionObj.localizationId, actionObj.questionType, actionObj.resolve);
    if(updatedQuestion) {
        yield put( createAnswerSuccess(actionObj.questionID, updatedQuestion) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{answerId, questionID, question, type}>>}
 */
function* updateAnswer(actionObj){
    const updatedQuestion = yield requestAnswerUpdating(actionObj.questionID,  actionObj.answerId, actionObj.answer, actionObj.questionType, actionObj.resolve);

    yield put( putActionActionBuffer(
        {
            actionBuff: [
                {
                    'updateAnswer': {
                        questionID: actionObj.questionID,
                        answerId: actionObj.answerId,
                        type: actionObj.questionType,
                        content: {
                            ...actionObj.answer
                        }
                    }
                }
            ]
        }
    ) )
    if(updatedQuestion) {
        yield put( updateAnswerSuccess(updatedQuestion.question_id, updatedQuestion, actionObj.answerId));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* deleteAnswer(actionObj){
    const updatedQuestion = yield requestAnswerDeleting(actionObj.answerId, actionObj.questionType, actionObj.resolve);
    if(updatedQuestion) {
        yield put( deleteAnswerSuccess(updatedQuestion.question_id, updatedQuestion));
    }
}

/**
 *
 * @param bindObjectId
 * @param typeId
 * @param answerId
 * @param answerType
 * @param points
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* bindTypeToAnswer({bindObjectId,typeId,answerId,answerType,points}) {
    const updatedQuestion = yield requestBindTypeToAnswer({bindObjectId,typeId,answerId,answerType,points});
    if(updatedQuestion){
        yield put(bindTypeToAnswerSuccess(updatedQuestion));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchAnswers(){
    yield takeEvery(CREATE_ANSWER, createAnswer);
    yield takeLatest(UPDATE_ANSWER, updateAnswer);
    yield takeLatest(DELETE_ANSWER, deleteAnswer);
    yield takeLatest(BIND_TYPE_TO_ANSWER, bindTypeToAnswer);
}

export default watchAnswers;